/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@mui/material";
import React, { useRef } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductCard from "../productCard";
import { useRouter } from "next/navigation";
import { Product } from "@/types/General";

interface HomeRecommendedProductsProps {
  products?: Product[];
  categoryId?: number | string;
}

const CustomNextArrow = (props: any) => {
  const { className, onClick } = props;
  return (
    <div
      className={`custom-slick-arrow next-arrow ${className}`}
      onClick={onClick}
    >
      <KeyboardArrowRightIcon />
    </div>
  );
};

const CustomPrevArrow = (props: any) => {
  const { className, onClick } = props;
  return (
    <div
      className={`custom-slick-arrow prev-arrow ${className}`}
      onClick={onClick}
    >
      <KeyboardArrowLeftIcon />
    </div>
  );
};

function HomeRecommendedProducts({ products, categoryId }: HomeRecommendedProductsProps) {
  const router = useRouter();
  type Slider = any;
  const sliderRef = useRef<Slider | null>(null);

  // Don't render if no products or products array is empty
  if (!products || !Array.isArray(products) || products.length === 0) {
    return null;
  }

  // Get category ID from prop or from first product's category
  const resolvedCategoryId = categoryId || products?.[0]?.category?.id;
  const settings = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: true,
        },
      },
    ],
  };

  return (
    <>
      <section className="product_sc">
        <div className="container">
          <div className="s_head flex hd_4">
            <h2>Today's Recommendation Section</h2>
            <div className="rt">
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  const url = resolvedCategoryId
                    ? `/product/product-category?category_id=${resolvedCategoryId}&type=recommended`
                    : "/product/product-category?type=recommended";
                  router.push(url);
                }}>
                More <KeyboardArrowRightIcon />
              </Button>
            </div>
          </div>

          <Slider ref={sliderRef} {...settings} className="products_card_list">
            {products?.map((item, index) => (
              <ProductCard key={`home-recommended-${item.product_id || 'no-id'}-${item.store_id || 'no-store'}-${index}`} product={item} />
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default HomeRecommendedProducts;
